import React from 'react';
import { Grid } from '@mui/material';
import FormInput from '../../../inputs/FormInput';
import useCurrency from '../../../../hooks/common/useCurrency';

const PricingTab = ({
    price,
    setPrice,
    compareAtPrice,
    setCompareAtPrice,
    cost,
    setCost,
    weightGrams,
    setWeightGrams,
    isTaxable,
    setIsTaxable,
    isArabic
}) => {
    const { currency } = useCurrency();
    return (
        <Grid container spacing={3}>
            <Grid item xs={12} md={3}>
                <FormInput
                    label={isArabic ? `السعر (${currency})` : `Price (${currency})`}
                    type="number"
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                    required
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <FormInput
                    label={isArabic ? 'السعر المقارن' : 'Compare at Price'}
                    type="number"
                    value={compareAtPrice}
                    onChange={(e) => setCompareAtPrice(e.target.value)}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <FormInput
                    label={isArabic ? 'التكلفة' : 'Cost'}
                    type="number"
                    value={cost}
                    onChange={(e) => setCost(e.target.value)}
                />
            </Grid>
            <Grid item xs={12} md={3}>
                <FormInput
                    label={isArabic ? 'الوزن (جرام)' : 'Weight (Grams)'}
                    type="number"
                    value={weightGrams}
                    onChange={(e) => setWeightGrams(e.target.value)}
                />
            </Grid>
            <Grid item xs={12}>
                <FormInput
                    label={isArabic ? 'هذا المنتج خاضع للضريبة؟ (سيتم احتساب الضريبة تلقائياً)' : 'Is this product taxable? (Tax will be calculated automatically)'}
                    type="switch"
                    checked={isTaxable}
                    onChange={(e) => setIsTaxable(e.target.checked)}
                />
            </Grid>
        </Grid>
    );
};

export default PricingTab;
